const vars = {
  root: "/",
  assets: "/assets/",
  uaset: {
    pc: ".win, .mac, .linux",
    sp: ".iphone, .ipod, .ipad, .android, .windowsphone",
  },
  arrs: (n) => {
    var arr = []
    for(var i = 0; i < n; i++){
      arr.push(i)
    }
    return arr
  }
}

export default vars



// WEBPACK FOOTER //
// ./_src/js/vars.js